import Settings from "@repositories/settings";
import { useQuery } from "react-query";
import { SettingsOptions } from "@ts-types/generated";
import { API_ENDPOINTS } from "@utils/api/endpoints";
import { QueryParamsType } from "@ts-types/custom.types";

type SettingsQueryOptions = {
  name?: string;
};

export const fetchSettings = async ({ queryKey }: QueryParamsType) => {
  const [_key, params] = queryKey;
  let url = API_ENDPOINTS.SETTINGS;

  if((params as SettingsQueryOptions)?.name) {
    const { name } = params as SettingsQueryOptions;
    url += `?name=${name}`
  }
  const { data } = await Settings.all(url);
  return data;
};

export const useSettingsQuery = (params?: SettingsQueryOptions) => {
  return useQuery<SettingsOptions, Error>([API_ENDPOINTS.SETTINGS, params], fetchSettings, { staleTime: 60 * 1000 });
};
